/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import * as _l from 'lodash';

import permissions from '../../../common/constants/permissions';

import { AlertEventInfo } from 'services/lib/dto/AlertEventInfo';

import './log.scss';
import './log.tpl.html';

angular
  .module('admin.log', [
    'services.alertEvents',
    'services.error',
    'services.util',
    'services.permissions',
    'sbsf.enums'
  ])
  .constant('STATES', {
    FAILURE: 'FAILURE',
    SUCCESS: 'SUCCESS',
    PARTIAL: 'PARTIAL'
  })
  .controller('AdminLogCtrl', [
    '$scope',
    '$rootScope',
    '$state',
    '$filter',
    '$q',
    'httpActions',
    'batchUtils',
    'AlertEventService',
    'ErrorService',
    'UtilService',
    'BulkRestoreType',
    'permissionService',
    'MOBILE_EVENTS',
    'TYPE_ICON_CLASS',
    'STATES',
    'RESULT_KEYS',
    'VIEW_STATES',
    'JOB_TYPE',
    function (
      $scope,
      $rootScope,
      $state,
      $filter,
      $q,
      httpActions,
      batchUtils,
      AlertEventService,
      ErrorService,
      UtilService,
      BulkRestoreType,
      permissionService,
      MOBILE_EVENTS,
      TYPE_ICON_CLASS,
      STATES,
      RESULT_KEYS,
      VIEW_STATES,
      JOB_TYPE
    ) {
      const i18n = $filter('i18n');

      $scope.getAlertClass = getAlertClass;
      $scope.getEventDescription = getEventDescription;
      $scope.getIconClass = getIconClass;
      $scope.isBackup = isBackup;
      $scope.loadAlertEvents = loadAlertEvents;

      $scope.actions = [];

      loadLogData();

      /**
       * Loads the log data
       */
      function loadLogData() {
        if (!$scope.$parent.isExpiredOrg) {
          const limit = 10;
          return httpActions
            .getFinishedActions(limit)
            .then((actions) => {
              $scope.actions = actions.rows;
              return loadAlertEvents();
            })
            .catch((err) => {
              ErrorService.report(err, i18n('LOAD_LOG_DATA_FAILED'));
            });
        }
      }

      /**
       * Determines whether any backup generated alerts.
       *
       * @returns {Promise} the promise of completion.
       */
      function loadAlertEvents() {
        const promises = [];

        _l.each($scope.actions, (action) => {
          if (isBackup(action)) {
            const promise = AlertEventService.getEventsForBatch(action.batchId)
              .then((events) => {
                action.events = events;
              })
              .catch(function (err) {
                ErrorService.report(err);
              });

            promises.push(promise);
          }
        });

        return $q.all(promises);
      }

      /**
       * Determines whether an action is a backup action.
       *
       * @param {object} action - the action to check.
       * @returns {boolean} true if the action is a type of backup.
       */
      function isBackup(action) {
        return (
          action.type === 'CUSTOM_TIME_BACKUP' || action.type === 'MANUAL_BACKUP' || action.type === 'SCHEDULED_BACKUP'
        );
      }

      /**
       * Determines the alert class for an action. Only backups can have alerts.
       *
       * @param {object} action - the action whose alert class is desired.
       * @returns {string} - the icon class
       */
      function getAlertClass(action) {
        return isBackup(action) && _.size(action.events) > 0 ? 'sbsf-backup-alert' : '';
      }

      /**
       * Returns the description of an alert event.
       *
       * @param {object} event - the event whose description is desired.
       * @returns {string} - the description
       */
      function getEventDescription(event) {
        return AlertEventInfo.getDescription(event);
      }

      /**
       * Determines the icon class for an action
       *
       * @param {object} action - the action whose icon class is desired.
       * @returns {string} - the icon class
       */
      function getIconClass(action) {
        return TYPE_ICON_CLASS[action.status] || TYPE_ICON_CLASS.PARTIAL;
      }

      /**
       * Function used to build leading message shown in the action table.
       *
       * @param {Object} action An action object return from the server.
       * @param {Number} action.action The action being executed.
       * @param {Number} action.status The status of the action.
       * @param {Date} action.date The Date this action completed.
       *
       * @returns {*|string} A html code block.
       */
      $scope.getMessage = function (action) {
        var typeMessage;

        // Construct the downloaded message for which type was downloaded
        if (action.type === 'DOWNLOAD_BATCH_OUTPUT') {
          typeMessage = i18n('DOWNLOADED', i18n(action.downloadedType));
        } else if (action.type === 'BULK_RESTORE_CSV_VERIFICATION') {
          const parentJobType = batchUtils.getParentJobTypeForCsvVerification(action.bulkRestoreCsvVerificationData);
          typeMessage = i18n(`CSV_VERIFICATION_FOR_${parentJobType}`);
        } else {
          typeMessage = i18n(action.type || 'BACKUP');
        }

        return typeMessage;
      };

      /**
       * Returned the formatted date string from an
       * action object.
       *
       * @param {string} actionDate A string date.
       * @returns {string} A formatted date string.
       */
      $scope.getDateTime = function (actionDate) {
        return moment(actionDate).format('ddd,  MMM D[,] YYYY hh:mm A');
      };

      $scope.getUsername = function (data) {
        if (!data) {
          return '';
        }
        if (data.displayName && data.loginType && data.loginType.scope === 'EXTERNAL') {
          return data.displayName;
        }
        return data.username;
      };

      /**
       * For backup objects get the percentage done.
       *
       * @param {object} action - The action model object.
       * @returns {string} A percent complete.
       */
      $scope.getPctComplete = function (action) {
        //TODO: will need an update after adding exports
        return batchUtils.getBatchPercent(action) + '%';
      };

      /**
       * Returned the formatted status string from an
       * activity object.
       *
       * @param {object} activity - The activity object.
       * @returns {string} A formatted status string.
       */
      $scope.getStatus = function (activity) {
        var statusMsg;
        if (activity.status === RESULT_KEYS.PARTIAL) {
          statusMsg = i18n('PARTIAL_MSG', activity.percentComplete);
        } else {
          statusMsg = i18n(activity.status);
        }
        return statusMsg;
      };

      /**
       * Handler for all history button that direct the app to the history log.
       */
      $scope.gotoHistory = function () {
        // Scroll to the top before we show the Activity History tab
        UtilService.scrollHome();
        $state.go(VIEW_STATES.LOG_HOME);
      };

      /**
       * Handler for all history button that direct the app to the mobile history log.
       */
      $scope.goToMobileHistory = function () {
        $rootScope.$emit(MOBILE_EVENTS.HEADER_CHANGE, {
          title: i18n('ACTIVITY'),
          previous: VIEW_STATES.MOBILE_HOME
        });

        $state.go(VIEW_STATES.MOBILE_ACTIVITY_LOGS);
      };

      /**
       * Redirect the view to the batch detail view.
       */
      $scope.goToBatch = function (selectedBatch) {
        var params;

        // Scroll to the top before we show the batch
        UtilService.scrollHome();

        batchUtils.currentBatch = selectedBatch;
        if (batchUtils.isBatchExportType(selectedBatch)) {
          $state.go(VIEW_STATES.BATCH_EXPORT, { batchId: batchUtils.currentBatch.batchId });
        } else if (selectedBatch.type === 'OBJECT_RESTORE') {
          $state.go(VIEW_STATES.BATCH_OBJECT_RESTORE, { batchId: batchUtils.currentBatch.batchId });
        } else if (selectedBatch.type === 'BULK_RESTORE' || selectedBatch.type === 'CROSS_ORG_RESTORE') {
          params = {
            batchId: selectedBatch.batchId
          };
          $state.go(VIEW_STATES.BATCH_BULK_RESTORE, params);
        } else if (selectedBatch.type === 'BULK_RESTORE_CSV_VERIFICATION') {
          const parentJobType = batchUtils.getParentJobTypeForCsvVerification(
            selectedBatch.bulkRestoreCsvVerificationData
          );
          const stateToGo = batchUtils.getStateToGoAfterCsvVerification(parentJobType);

          let permission = null;
          if (parentJobType === JOB_TYPE.BULK_RESTORE) {
            permission = permissions.RESTORE;
          }
          if (parentJobType === JOB_TYPE.EXPORT) {
            permission = permissions.EXPORT;
          }

          permissionService.hasPermission(permission).then((hasPermission) => {
            if (hasPermission) {
              $state.go(stateToGo, {
                bulkRestoreType: BulkRestoreType.VERIFIED_CSV,
                batch: selectedBatch
              });
            }
          });
        } else if (selectedBatch.type === 'METADATA_COMPARE') {
          params = {
            batchId: selectedBatch.batchId
          };

          $state.go(VIEW_STATES.METADATA_COMPARE_RESULTS, params);
        } else if (selectedBatch.type === 'DOWNLOAD_BATCH_OUTPUT') {
          batchUtils.currentBatch = selectedBatch.batchOutputDownloadedId;
          $state.go(VIEW_STATES.BATCH_EXPORT, { batchId: selectedBatch.batchOutputDownloadedId });
        } else if (selectedBatch.type === 'METADATA_RESTORE') {
          $state.go(VIEW_STATES.BATCH_METADATA_RESTORE, { batchId: batchUtils.currentBatch.batchId });
        } else if (selectedBatch.type.startsWith('GDPR_')) {
          $state.go(VIEW_STATES.BATCH_GDPR_REQUEST, { batchId: batchUtils.currentBatch.batchId });
        } else {
          $state.go(VIEW_STATES.BATCH_HOME, { batchId: batchUtils.currentBatch.batchId });
        }
      };

      /**
       * Redirect the view to the mobile batch detail view.
       */
      $scope.goToMobileBatch = function (selectedBatch) {
        batchUtils.currentBatch = selectedBatch;
        const batchDate = batchUtils.getTitleBatchDate();

        $rootScope.$emit(MOBILE_EVENTS.HEADER_CHANGE, {
          title: batchDate,
          previous: VIEW_STATES.MOBILE_HOME
        });

        if (selectedBatch.type === 'EXPORT' || selectedBatch.type === 'BULK_RESTORE_PREVIEW') {
          $state.go(VIEW_STATES.MOBILE_BATCH_EXPORT, { batchId: batchUtils.currentBatch.batchId });
        } else if (selectedBatch.type === 'OBJECT_RESTORE') {
          $state.go(VIEW_STATES.MOBILE_BATCH_OBJECT_RESTORE, { batchId: batchUtils.currentBatch.batchId });
        } else if (selectedBatch.type === 'BULK_RESTORE') {
          $state.go(VIEW_STATES.MOBILE_BATCH_BULK_RESTORE, { batchId: batchUtils.currentBatch.batchId });
        } else {
          $state.go(VIEW_STATES.MOBILE_BATCH_HOME, { batchId: batchUtils.currentBatch.batchId });
        }
      };

      // Anytime that the backup, export, or bulk restore status goes to false refresh the apiCount
      $scope.$watch(
        function () {
          return $scope.backupInProgress;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && !$scope.backupInProgress) {
            loadLogData();
          }
        }
      );

      $scope.$watch(
        function () {
          return $scope.exportInProgress;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && !$scope.exportInProgress) {
            loadLogData();
          }
        }
      );

      $scope.$watch(
        function () {
          return $scope.bulkRestoreInProgress;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && !$scope.bulkRestoreInProgress) {
            loadLogData();
          }
        }
      );

      $scope.$watch(
        function () {
          return $scope.bulkRestorePreviewInProgress;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && !$scope.bulkRestorePreviewInProgress) {
            loadLogData();
          }
        }
      );

      $scope.$watch(
        function () {
          return $scope.bulkRestoreCsvVerificationInProgress;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && !$scope.bulkRestoreCsvVerificationInProgress) {
            loadLogData();
          }
        }
      );

      $scope.$watch(
        function () {
          return $scope.metadataCompareInProgress;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && !$scope.metadataCompareInProgress) {
            loadLogData();
          }
        }
      );

      $scope.$watch(
        function () {
          return $scope.metadataRestoreInProgress;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && !$scope.metadataRestoreInProgress) {
            loadLogData();
          }
        }
      );

      $scope.$watch(
        function () {
          return $scope.gdprOperationInProgress;
        },
        function (newValue, oldValue) {
          if (newValue !== oldValue && !$scope.gdprOperationInProgress) {
            loadLogData();
          }
        }
      );

      /**
       * Return the html for the action in the mobile view.
       *
       * @param {object} action - The action object.
       * @returns {string} An html string representing the action.
       */
      $scope.getMobileMessage = function (action) {
        return $filter('mobileBatchMessage')(action);
      };
    }
  ]);
